export const COOKIE_NAME = "i18n-language";
export const COOKIE_DAYS = 30;
export const SUPPORTED_LOCALES: string[] = ["fr", "en", "nl"];
